export const MORTGAGE_MODIFICATION_LOADING = 'MORTGAGE_MODIFICATION_LOADING';
export const MORTGAGE_MODIFICATION_ERROR = 'MORTGAGE_MODIFICATION_ERROR';
export const INITIATE_MORTGAGE_MODIFICATION_APPLICATION_SUCCESS = 'INITIATE_MORTGAGE_MODIFICATION_APPLICATION_SUCCESS';
export const RESET_MORTGAGE_MODIFICATION_REDUCER = 'RESET_MORTGAGE_MODIFICATION_REDUCER';
export const FETCH_APPLICATION_MORTGAGE_MODIFICATION_SUCCESS = 'FETCH_APPLICATION_MORTGAGE_MODIFICATION_SUCCESS';
export const MORTGAGE_MODIFICATION_CLEAR_DATA = 'MORTGAGE_MODIFICATION_CLEAR_DATA';
export const MORTGAGE_MODIFICATION_CANCEL_APPLICATION_SUCCESS = 'MORTGAGE_MODIFICATION_CANCEL_APPLICATION_SUCCESS';
export const ADD_TO_ERROR = 'ADD_TO_ERROR';
export const CHANGE_MORTGAGE_MODIFICATION_STEP = 'CHANGE_MORTGAGE_MODIFICATION_STEP';
export const UPDATE_SELECTED_PERMISSION = 'UPDATE_SELECTED_PERMISSION';
export const FETCH_MULTI_PROPERTIES_SUCCESS = 'FETCH_MULTI_PROPERTIES_SUCCESS';
export const FETCH_SINGLE_PROPERTY_DETAILS_SUCCESS = 'FETCH_SINGLE_PROPERTY_DETAILS_SUCCESS';
export const RELEASE_MORTGAGE_DOCUMENT_RESPONSE = 'RELEASE_MORTGAGE_DOCUMENT_RESPONSE';
export const FETCH_PAYMENT_BREAKDOWN_SUCCESS = 'FETCH_PAYMENT_BREAKDOWN_SUCCESS';
export const STOP_LOADING_WITH_NO_ERROR = 'STOP_LOADING_WITH_NO_ERROR';
export const CHANGE_FEES_FORM = 'CHANGE_FEES_FORM';
export const CALCULATE_FEES_SUCCESS = 'CALCULATE_FEES_SUCCESS';
export const FETCH_LOOKUPS_START = 'FETCH_LOOKUPS_START';
export const FETCH_LOOKUPS_SUCCESS = 'FETCH_LOOKUPS_SUCCESS';
export const DELETE_PROPERTY_FROM_MORTGAGE_SUCCESS = 'DELETE_PROPERTY_FROM_MORTGAGE_SUCCESS';
export const FETCH_PROPERTY_OWNERS_SUCCESS = 'FETCH_PROPERTY_OWNERS_SUCCESS';
export const FETCH_VALUATOR_LOOKUPS_SUCCESS = 'FETCH_VALUATOR_LOOKUPS_SUCCESS';

export const RESET_MORTGAGE_MODIFICATION_ERROR = 'RESET_MORTGAGE_MODIFICATION_ERROR';
export const FORM_ERROR = 'FORM_ERROR';
